/* eslint-disable react/prop-types */
import React from 'react';
import {
  PaymentElement,
  useStripe, useElements,
} from '@stripe/react-stripe-js';
import request from '@api';
import useConnectionContext from '@hooks/useConnectionContext';
import { message } from 'antd';

export default function SetupForm({
  onReady, ready,
}) {
  const [errorMessage, setErrorMessage] = React.useState('');
  const stripe = useStripe();
  const [disable, setDisable] = React.useState(false);
  const elements = useElements();

  const { queryConnection } = useConnectionContext();
  let { current: timerId } = React.useRef();

  const submitHandler = async () => {
    if (disable) {
      return;
    }

    if (!stripe || !elements) {
      return;
    }
    const { setupIntent, error } = await stripe.confirmSetup({
      elements,
      redirect: 'if_required',
    });
    if (error) {
      setErrorMessage(error.message);
    } else {
      const { id, payment_method: paymentMethodId } = setupIntent;
      const onbording = await request('stripe-agreement/bind-account', {
        path: '/gateway/merchant-service/api/open-platform/',
        method: 'POST',
        body: {
          setupIntentId: id,
          paymentMethodId,
        },
      });
      const { code } = onbording;
      setErrorMessage(code === 0 ? '' : 'We\'re sorry, but we weren\'t able to add this card. Please try again later.');
      if (code === 0) {
        message.success('Your payment method have been saved.');
        queryConnection();
      }
    }
    setDisable(true);
  };

  React.useEffect(() => {
    clearTimeout(timerId);
    if (errorMessage) {
      timerId = setTimeout(() => {
        setErrorMessage('');
        setDisable(false);
      }, 5 * 1000);
    }
  }, [errorMessage, timerId]);
  return (
    <div className="seel_stripe_form">

      <PaymentElement
        onReady={onReady}
        options={
          {
            wallets: {
              applePay: 'never',
              googlePay: 'never',
            },
          }
        }
      />
      {errorMessage ? <div className="seel_stripe_element_error">{errorMessage}</div> : null}
      <div
        className="seel_stripe_submit_button"
        style={!ready || disable ? {
          backgroundColor: '#C8C5FF',
        } : {}}
        onClick={submitHandler}
      >
        Save card
      </div>
    </div>
  );
}
